import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../fragments/button';
import {FormInline} from '../../../fragments/forms';
import RawDataCollection from '../../../../models/raw-data-collection';
import {getStorage, updateStorage} from '../../../../utils/storage';

import style from './style.css';


export default class SuscResultsOpt extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired
  };

  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object
    }).isRequired
  };

  constructor() {
    super(...arguments);
    this.state = {
      loading: true,
      loadDataError: false,
      rawDataCollection: new RawDataCollection()
    };
  }

  async componentDidMount() {
    const {location: {query}} = this.props;
    if (!query || !('load' in query)) {
      this.setState({loadDataError: true, loading: false});
      return;
    }
    const {rawDataCollection} = (await getStorage(query.load));
    this.setState({
      loading: false,
      rawDataCollection
    });
  }

  handleClick(hasPhenotype) {
    return async () => {
      const {rawDataCollection} = this.state;
      const pathname = hasPhenotype ? '/wizard/susc-results' : '/wizard/finish';
      const state = {
        pathname: this.props.location.pathname,
        rawDataCollection
      };
      const load = await updateStorage(state);
      this.context.router.push({
        pathname,
        query: {load}
      });
    };
  }

  render() {
    const {references} = this.state.rawDataCollection;
    const multiRef = references.length > 1;

    return <div>
      <p>
        Is phenotype data also included in {multiRef ? "these studies" : "this study"}?
      </p>
      <FormInline className={style.form}>
        <Button
         onClick={this.handleClick(true)}
         btnStyle="primary">Yes</Button>
        <Button
         onClick={this.handleClick(false)}
         btnStyle="default">No</Button>
      </FormInline>
    </div>;

  }


}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/opt/index.js